import { AdminRoute } from 'app/route/admin';
import { NavigationNode } from 'model/NavigationNode';
import { compilePath } from 'router/compilePath';

export namespace AdminLeftMenuLinks {
  export const project = (id: number): NavigationNode[] => {
    const companyChildren = [
      {
        id: 'settings',
        label: 'Settings',
        href: compilePath(AdminRoute.Project.COMPANY_SETTINGS_PATTERN, { id }),
        pattern: AdminRoute.Project.COMPANY_SETTINGS_PATTERN,
      },
    ];

    return [
      {
        label: 'Company',
        children: companyChildren,
      },
      {
        label: 'People',
        children: [
          {
            id: 'attributes',
            label: 'Attributes',
            href: compilePath(AdminRoute.Project.People.ATTRIBUTES_DEMOGRAPHICS, { id }),
            pattern: AdminRoute.Project.People.ATTRIBUTES_PATTERN,
          },
          {
            id: 'employees',
            label: 'Employees',
            href: compilePath(AdminRoute.Project.People.EMPLOYEES, { id }),
            pattern: AdminRoute.Project.People.EMPLOYEES,
          },
          {
            id: 'accessControl',
            label: 'Access Control',
            href: compilePath(AdminRoute.Project.People.USERS_PATTERN, { id }),
            pattern: AdminRoute.Project.People.DASHBOARD_PERMISSIONS_PATTERN,
          },
        ],
      },
      {
        label: 'Survey',
        children: [
          {
            id: 'surveyQuestions',
            label: 'Survey Questions',
            href: compilePath(AdminRoute.Project.Survey.DEVELOP_PATTERN, { id }),
            pattern: AdminRoute.Project.Survey.DEVELOP_PATTERN,
          },
          {
            id: 'surveySettings',
            label: 'Survey Settings',
            href: compilePath(AdminRoute.Project.Survey.SETTINGS, { id }),
            pattern: AdminRoute.Project.Survey.SETTINGS,
          },
        ],
      },
      {
        label: 'Survey Distribution',
        href: compilePath(AdminRoute.Project.DISTRIBUTION_PATTERN, { id }),
        children: [
          {
            id: 'email',
            label: 'E-mail',
            href: compilePath(AdminRoute.Project.Distribution.EMAIL_PATTERN, { id }),
            pattern: AdminRoute.Project.Distribution.EMAIL_PATTERN,
          },
          {
            id: 'webLink',
            label: 'Web Link',
            href: compilePath(AdminRoute.Project.Distribution.WEB_LINK_PATTERN, { id }),
            pattern: AdminRoute.Project.Distribution.WEB_LINK_PATTERN,
          },
          {
            id: 'kioskMode',
            label: 'Kiosk Mode',
            href: compilePath(AdminRoute.Project.Distribution.KIOSK_PATTERN, { id }),
            pattern: AdminRoute.Project.Distribution.KIOSK_PATTERN,
          },
        ],
      },
      {
        label: 'Trending',
        children: [
          {
            id: 'benchmarkData',
            label: 'Benchmark Data',
            href: compilePath(AdminRoute.Project.Trending.BENCHMARK_DATA_PATTERN, { id }),
            pattern: AdminRoute.Project.Trending.BENCHMARK_DATA_PATTERN,
          },
          {
            id: 'trendData',
            label: 'Trend Data',
            href: compilePath(AdminRoute.Project.Trending.TREND_DATA_PATTERN, { id }),
            pattern: AdminRoute.Project.Trending.TREND_DATA_PATTERN,
          },
        ],
      },
      {
        label: 'Data',
        children: [
          {
            id: 'dataExport',
            label: 'Data Export',
            href: compilePath(AdminRoute.Project.Data.EXPORT_PATTERN, { id }),
            pattern: AdminRoute.Project.Data.EXPORT_PATTERN,
          },
          {
            id: 'downloads',
            label: 'Downloads',
            href: compilePath(AdminRoute.Project.Data.DOWNLOADS_PATTERN, { id }),
            pattern: AdminRoute.Project.Data.DOWNLOADS_PATTERN,
          },
          {
            id: 'importSurvey',
            label: 'Import Survey',
            href: compilePath(AdminRoute.Project.Data.IMPORT_SURVEY_PATTERN, { id }),
            pattern: AdminRoute.Project.Data.IMPORT_SURVEY_PATTERN,
          },
          {
            id: 'manageSurveys',
            label: 'Manage surveys',
            href: compilePath(AdminRoute.Project.Data.MANAGE_SURVEY_PATTERN, { id }),
            pattern: AdminRoute.Project.Data.MANAGE_SURVEY_PATTERN,
            requiredRoles: ['ROLE_PROJECT_DATE_CHANGER'],
          },
        ],
      },
    ];
  };
}
